import { getNamespaceForRestaurant } from "./mapEnv";

function publicPath(filepath) {
    return String(filepath).startsWith("/") ?
        filepath.substr(0, 1) :
        filepath || "";
}

function assetsPath(filepath) {
    return String(filepath).startsWith("/") ?
        String.prototype.concat("assets", filepath) :
        String.prototype.concat("assets", "/", filepath) || "";
}

function assetsNamespacedPath(filepath, id) {
    let namespace = getNamespaceForRestaurant(id);

    return String(filepath).startsWith("/") ?
        assetsPath(String.prototype.concat(namespace, filepath)) :
        assetsPath(String.prototype.concat(namespace, "/", filepath)) || "";
}

function assetsLogoPath(id) {
    let path = assetsNamespacedPath("logo.png", id);

    if (String(id).match("1027")) {
        path = assetsPath("espolon/logo.png");
    } if (String(id).match("8383")) {
        path = assetsPath("bluenote/logo.jpeg");
    } if (String(id).match("14878")) {
        path = assetsPath("flowine/logo.png");
    } if (String(id).match("14844")) {
        path = assetsPath("rossooltremare/logo.png");
    }

    return path;
}

const assets = {
    publicPath,
    assetsPath,
    assetsNamespacedPath,
    assetsLogoPath,
};
export default assets;
